import React from 'react'
import { StoresContext } from "../context/storesContext";


export const useStores = () => React.useContext(StoresContext);